import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from '../../useService';
import useUserService from '../../../../userManagement/utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';
import { getFormDefaults } from './helper';

export interface IFormData {
	actions: string;
	permissions?: string;
	permissionsSet?: string;
	expiresAfter?: number;
	isMasked?: boolean;
}

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { showAlert, app } = useContext(AppContext);
	const { requestAssignPermissions, requestRemovePermissions } = useService();
	const { getPermissionSetOptions, getPermissionsOptions } = useUserService();
	const location = useLocation();
	const userIdList: string[] = _get(location, ['state', 'userIdList']);
	const data = getFormDefaults();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.PERMISSIONS].setRenderProps({ getOptions: getPermissionsOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.PERMISSIONS_SET].setRenderProps({ getOptions: getPermissionSetOptions });
	const assignPermissions = async (formData: IFormData) => {
		setShowLoader(true);
		try {
			const response = await requestAssignPermissions(app.appName, { formData, userIdList });
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to assign permissions');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while assign Permissions', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permissions Assign successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};
	const removePermissions = async (formData: IFormData) => {
		setShowLoader(true);
		try {
			const response = await requestRemovePermissions(app.appName, { formData, userIdList });
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to remove Permissions');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while removing Permissions', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permissions removed successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (formData: IFormData) => {
		if (formData.actions === 'assign') {
			assignPermissions(formData);
		} else if (formData.actions === 'remove') {
			removePermissions(formData);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
